
import { globalErrorMsg } from '@bingads-webui-campaign/hotel-common-upsert';
import { validateBidAdjustment } from '../components/utility';

export function getUserSetDatesBasicConfig(i18n) {
  const columns = [
    {
      key: 'dates', name: '', fieldName: 'dates', minWidth: 100, maxWidth: 135, type: 'string', className: 'border-right', headerClassName: 'target-custom-header',
    },
  ];
  return {
    basicConfig: {
      columns,
      showAddBtn: false,
      showSettingToggle: true,
      titleKey: i18n.getString(_TL_('User set dates')),
      topicKey: 'pop_BA_CampaignTargets_UserSetDates',
      minBid: -50,
      maxBid: 100,
    },
  };
}

export const userSetDatesDefaultSetting = [
  {
    dates: _TL_('Selected date'),
    bidAdjustmentDropdown: 'Increase by',
    bidAdjustmentInput: 0,
  },
  {
    dates: _TL_('Default date'),
    bidAdjustmentDropdown: 'Increase by',
    bidAdjustmentInput: 0,
  }];

export const isUserSetDatesTargetValid = (userSetDates, patchErrMsg = function () { }) => {
  let isValid = true;

  userSetDates.filter(item => item.Status !== 'Deleted').forEach((item) => {
    let validateValue = item.bidAdjustmentInput;
    if (item.bidAdjustmentDropdown === 'Decrease by') {
      validateValue = -validateValue;
    }
    if (validateBidAdjustment({
      value: validateValue, min: -90, max: 900, extra: [-100],
    })) {
      isValid = false;
    }
  });

  if (isValid) {
    patchErrMsg('userSetDates', '');
  } else {
    patchErrMsg('userSetDates', globalErrorMsg);
  }
  return isValid;
};
